import { render, staticRenderFns } from "./bulkCreatePublisher.vue?vue&type=template&id=67d00636&"
import script from "./bulkCreatePublisher.vue?vue&type=script&lang=js&"
export * from "./bulkCreatePublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports